import axios from "axios";

const CACHE_KEY = "company_settings_cache_v1";
const CACHE_TTL_MS = 30 * 60 * 1000;

let cachedSettings = null;
let pendingRequest = null;

function readCache() {
  if (cachedSettings) return cachedSettings;
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > CACHE_TTL_MS) return null;
    cachedSettings = parsed.data || {};
    return cachedSettings;
  } catch {
    return null;
  }
}

function writeCache(data) {
  cachedSettings = data || {};
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ savedAt: Date.now(), data: cachedSettings }));
  } catch {
    // localStorage can be unavailable in private windows; in-memory cache still works.
  }
  return cachedSettings;
}

export async function getCompanySettingsCached({ force = false } = {}) {
  if (!force) {
    const cached = readCache();
    if (cached) return cached;
  }
  if (pendingRequest) return pendingRequest;
  pendingRequest = axios
    .get("/v1/company-settings")
    .then((response) => writeCache(response.data || {}))
    .finally(() => {
      pendingRequest = null;
    });
  return pendingRequest;
}

export function setCompanySettingsCache(data) {
  return writeCache(data || {});
}

export function clearCompanySettingsCache() {
  cachedSettings = null;
  pendingRequest = null;
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
